module.exports = __webpack_public_path__ + "img/12.031c0da4.jpg";